module.exports = __webpack_public_path__ + "static/media/lock.c4af5a4e.svg";